<template>
    <div class="space-y-6">
        <p class="text-sm text-gray-600 leading-relaxed">
            Чтобы загружать данные из Битрикс24, сначала привяжите портал к вашему аккаунту Tegrum.
            Следуйте шагам ниже.
        </p>

        <ol class="space-y-4">
            <li class="flex gap-4">
                <div class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
                    1
                </div>
                <div class="min-w-0 pt-0.5">
                    <div class="text-sm font-semibold text-gray-900">
                        Введите ссылку на ваш портал Битрикс24
                    </div>
                    <p class="text-sm text-gray-500 mt-1 leading-relaxed">
                        Домен должен быть вида https://company.bitrix24.ru
                    </p>
                </div>
            </li>

            <li class="flex gap-4">
                <div class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
                    2
                </div>
                <div class="min-w-0 pt-0.5">
                    <div class="text-sm font-semibold text-gray-900">
                        Нажмите кнопку установить приложение
                    </div>
                    <p class="text-sm text-gray-500 mt-1 leading-relaxed">
                        Вас переведёт на страницу вашего Битрикс24.
                    </p>
                </div>
            </li>

            <li class="flex gap-4">
                <div class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
                    3
                </div>
                <div class="min-w-0 pt-0.5">
                    <div class="text-sm font-semibold text-gray-900">
                        Завершите установку приложения нажав кнопку "Установить"
                    </div>
                    <p class="text-sm text-gray-500 mt-1 leading-relaxed">
                        Установите приложение Tergum и подтвердите запрос на доступ к данным портала.
                    </p>
                </div>
            </li>
            <li class="flex gap-4">
                <div class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
                    4
                </div>
                <div class="min-w-0 pt-0.5">
                    <div class="text-sm font-semibold text-gray-900">
                        Вернитесь в Tergum
                    </div>
                    <p class="text-sm text-gray-500 mt-1 leading-relaxed">
                        После успешной установки приложения нажмите на кнопку привязать аккаунт.
                    </p>
                </div>
            </li>
            <li class="flex gap-4">
                <div class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
                    5
                </div>
                <div class="min-w-0 pt-0.5">
                    <div class="text-sm font-semibold text-gray-900">
                        Завершите привязку аккаунта в открывшемся
                    </div>
                    <p class="text-sm text-gray-500 mt-1 leading-relaxed">
                        После установки вернитесь на Tergum. Ваш аккаунт появится в списке аккаунтов.
                    </p>
                </div>
            </li>
        </ol>

        <div class="rounded-lg border border-blue-100 bg-blue-50 px-4 py-3">
            <p class="text-sm text-blue-800">
                Если аккаунт не появился в списке, обновите страницу или проверьте, что установка приложения завершена в Битрикс24.
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>